// Phân loại file theo mimetype — dùng chung cho camera và các màn chụp ảnh.
export const isImage = (mimetype) => typeof mimetype === 'string' && mimetype.indexOf('image/') === 0
export const isVideo = (mimetype) => typeof mimetype === 'string' && mimetype.indexOf('video/') === 0
